/**
 * Toggle mobile menu.
 */

import $ from 'jquery';

$('.js-burger').on('click', function (e) {
	e.preventDefault();

	$(this).toggleClass('is-active');

	$('body').toggleClass('menu-is-open');
});
